import { useEffect, useState } from "react";

/** The mobile breakpoint shared with the CSS (`@media (max-width: 768px)`). */
export const MOBILE_MEDIA_QUERY = "(max-width: 768px)";

/** Synchronous one-shot check — safe outside React (SSR-guarded). */
export function isMobileViewport(): boolean {
  try {
    return window.matchMedia(MOBILE_MEDIA_QUERY).matches;
  } catch {
    return false;
  }
}

/** Reactive `isMobileViewport()` — re-renders on viewport crossings. */
export function useIsMobile(): boolean {
  const [mobile, setMobile] = useState<boolean>(() => isMobileViewport());
  useEffect(() => {
    let mql: MediaQueryList;
    try {
      mql = window.matchMedia(MOBILE_MEDIA_QUERY);
    } catch {
      return;
    }
    const onChange = (): void => setMobile(mql.matches);
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);
  return mobile;
}
